import { PagePath } from '../../../navigation/navigation.enums';

export function createDepartmentLink(companySlug: string, departmentId: number | string) {
  const slugged = PagePath.userManagementDepartmentPeople.replace(':companySlug', companySlug);
  return `${PagePath.userManagementBase}${slugged.replace(':departmentSlug', departmentId?.toString())}`;
}

export function createTeamLink(companySlug: string, teamId: number | string) {
  const slugged = PagePath.userManagementTeamPeople.replace(':companySlug', companySlug);
  return `${PagePath.userManagementBase}${slugged.replace(':teamSlug', teamId?.toString())}`;
}